export enum BannerEvents {
  Load = 'componentLoaded',
  SwitchNow = 'switchNow',
  OpenTariff = 'openTariff',
  LearnMore = 'learnMore',
  ExclusiveAction = 'exclusiveAction',
}

export enum BannerDynamicFields {
  MonthlyCost = 'monthlycost',
  AnnualCost = 'annualcost',
  TariffName = 'tariff',
  ExclusiveContent = 'exclusive-content',
  ExclusiveAction = 'exclusive-action'
}

export enum BannerPlacement {
  QuotesTag = 'TARIFF_CARD_TOP_LEFT',
  InfoTag = 'TARIFF_CARD_TOP_RIGHT',
  SupplierTag = 'TARIFF_CARD_SUPPLIER_TAG',
  PriceTag = 'TARIFF_CARD_PRICE_TAG',
  ExtraTag = 'TARIFF_CARD_EXTRA_TAG',
  LinkTag = 'Tariff_CARD_EXTRA_LINK',
  OnlyText = 'TARIFF_CARD_ONLY_TEXT',
  CTMRewards = 'TARIFF_CARD_CTM_REWARDS',
  ExtraAlternative = 'TARIFF_CARD_EXTRA_ALTERNATIVE',
  TariffDetailsInfo = 'TARIFF_CARD_TARIFF_DETAILS_INFO',
  TariffDetailsSmartMeter = 'TARIFF_DETAILS_SMART_METER',
  TariffDetailsRewards = 'TARIFF_DETAILS_REWARDS',
  
  // QuotesTag = 'TARIFF_CARD_OUTER_TOP_LEFT',
  TenancyBanner = 'QUOTES_PAGE_TOP_ZONE',
  EvTariff2 = 'TARIFF_CARD_OUTER_TOP_LEFT_2',
  PeakSaveSunday = 'TARIFF_CARD_INNER_TOP_RIGHT',
  ContractInfo = 'TARIFF_CARD_INNER_BELOW_CONTRACT',
  InfoBar = 'TARIFF_CARD_BELOW_TARIFF',
  SupplierRewards = 'TARIFF_CARD_SUPPLIER_REWARDS',
  TrackerInfo = 'TARIFF_CARD_TRACKER_INFO',
  EvTariff = 'TARIFF_CARD_INNER_TOP_LEFT'
}
